import { render } from "./ProgressBar.vue?vue&type=template&id=20bdd535"
import script from "./ProgressBar.vue?vue&type=script&lang=js"
export * from "./ProgressBar.vue?vue&type=script&lang=js"

import "./ProgressBar.vue?vue&type=style&index=0&id=20bdd535&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__